/* globals localStorage */
import axios from 'axios'
import constants from './constants'
import sha1 from 'sha1'
import api from 'sha1';

const axios_instance = axios.create({
    baseURL: constants.chillApiUrl,
    validateStatus: function (status) {
      return status >= 200 && status < 300;
    },
});

axios_instance.defaults.headers.common['Access-Control-Allow-Origin'] =  constants.chillApiUrl;
const USER_ID_KEY = 'user_id';
const USER_FULL_NAME_KEY = 'user_full_name';
const USER_IS_ADMIN_KEY = 'user_is_admin'
const USER_MANAGE_OWN_PASSES = 'user_manage_own_passes';
const USER_ORGANISATION_ID = 'user_organisation_id';
const SESSION_KEY = 'session';
const USER_HAS_MEMBERSHIP_PASS = 'user_has_membership_pass';
const USER_ALLOW_MANUAL_BARCODE = 'user_allow_manual_barcode';

var exports = {
    login(login, password) {
        var login = axios_instance.post('/api/users/login', {
            login: login,
            password: sha1(password)
        });
        login.then(res => {
            var user = res.data.ret_msg;
            localStorage.setItem(SESSION_KEY, user.session)
            localStorage.setItem(USER_ID_KEY, user.id)
            localStorage.setItem(USER_FULL_NAME_KEY, user.full_name)
            localStorage.setItem(USER_IS_ADMIN_KEY, user.is_admin)
            localStorage.setItem(USER_MANAGE_OWN_PASSES, user.manage_own_passes);
            localStorage.setItem(USER_ORGANISATION_ID, user.organisation_id);
            localStorage.setItem(USER_HAS_MEMBERSHIP_PASS, user.has_membership_pass);
            localStorage.setItem(USER_ALLOW_MANUAL_BARCODE, user.allow_manual_barcode);

            if(this.onAuthChange !== undefined) {
                this.onAuthChange(true)
            }
        })
        return login;
    },
    logout() {
        var logout = axios_instance.get('/api/users/logout');
        logout.then(res => {
            this.removeLocalUser();
        })
        return logout
    },
    getCurrentUser() {
        return axios_instance.get('/api/users/current_user');
    },
    getUserById() {
        return axios_instance.get('/api/users/current_user');
    },
    resetPassword(email) {
        return axios_instance.post('/api/users/password_reset_email', { email });
    },
    resetAppPassword(token, password) {
        return axios_instance.post('/api/app/password', {
          token: token,
          password: sha1(password)
        }); 
    },
    setPassword(email, password, passwordResetToken) {
        return axios_instance.put('/api/users/password', {
            email: email,
            passwordResetToken: passwordResetToken,
            password: sha1(password)
        });
    },
    retryNotReceivedEmail() {
        return axios_instance.post('/api/passes/retry-not-received', {});
    },
    async uploadPass(details) {
      const res = await axios_instance.post('/api/passes/create', details);
      return res.data.pass.passId;
    },
    editPass(passId, details) {
      return axios_instance.patch(`/api/passes/${passId}`, details);
    },
    loggedIn() {
        return !!this.userId()
    },
    onAuthChange(isLoggedIn) {

    },
    userId() {
        return localStorage.getItem(USER_ID_KEY)
    },
    userFullName() {
        return localStorage.getItem(USER_FULL_NAME_KEY)
    },
    userIsAdmin() {
        return localStorage.getItem(USER_IS_ADMIN_KEY) == "true"
    },
    canManageOwnPasses() {
      return localStorage.getItem(USER_MANAGE_OWN_PASSES) === "true"; 
    },
    getUserSession() {
        return  localStorage.getItem(SESSION_KEY)
    },
    getUserOrganisationId() {
      return localStorage.getItem(USER_ORGANISATION_ID);
    },
    getHasMembershipPass() {
      return localStorage.getItem(USER_HAS_MEMBERSHIP_PASS) === "true";
    },
    getAllowManualBarcode() {
      return localStorage.getItem(USER_ALLOW_MANUAL_BARCODE) === "true";
    },
    getAllPasses(params){
      return axios_instance.get('/api/passes/get_all_passes', {
          params: params
      });
    },
    getAllPassTypes(){
      return axios_instance.get('/api/passes/pass_types');
    },
    getOrganisationPassTypes(organisationId) {
      return axios_instance.get(`/api/pass_types/pass_types/${organisationId}`); 
    },
    getChillPassTypes(){
      return axios_instance.get('/api/pass_types/chill_pass') 
    },
    getAllPassesAsCsv(params){
      return axios_instance.get('/api/passes/get_all_passes/csv', {
          params: params
      });
    },
    getAllPassTypes(params){
      return axios_instance.get('/api/pass_types/pass_types', {
        params: params
      })
    },
    updateOrInsertPassType(params, imageFile){
      const data = new FormData();
      const pass = {
        id: params.id || null,
        name: params.name,
        price: params.price,
        type: params.type,
        replace_lost: params.replace_lost,
        age: params.age,
        days_limit: params.days_limit,
        organisations: params.organisations.filter(x => x.enabled === true || x.enabled === "true")
      };

      if (this.userIsAdmin()) {
        pass.organisation_id = params.organisation_id; 
      }

      data.append("pass", JSON.stringify(pass));
      data.append("image", imageFile);

      return axios_instance.post('/api/pass_types/', data)
    },
    getAllPassTypeDetails(id){
      return axios_instance.get('/api/pass_types/' + id)
    },
    deletePassType(id){
      return axios_instance.delete('/api/pass_types/' + id)
    },
    getPassesByHolderId(id){
      return axios_instance.get('/api/passes/passholder/' + id);
    },
    getPassById(id) {
      return axios_instance.get('/api/passes/' + id);
    },
    getPassesByTypeId(typeId){
      return axios_instance.get('/api/passes/type/'+ typeid);
    },
    getPassByScan(scantext) {
      return axios_instance.get('/api/passes/scan/' + scantext);
    },
    getPassesByRfid(rfid){
      return axios_instance.get('/api/passes/rfid/' + rfid);
    },
    getPassesByBarcode(barcode){
      return axios_instance.get('/api/passes/' + barcode);
    },
    getPassesByDisabledStatus(disabled){
      return axios_instance.get('/api/passses' + disabled);
    },
    getPassesByBillableStatus(billable){
      return axios_instance.get('/api/passses' + billable);

    },
    createPass(passHolderId, typeId, disabled, billable, rfid, barcode, notes) {
      return axios_instance.post('/api/passses', {
        pass: {
          pass_holder_id: passHolderId,
          type_id: typeId,
          disabled: disabled,
          billable: billable,
          rfid: rfid,
          barcode: barcode,
          notes: notes
        }
      });
  },
  updateCheckIn(check_in_row){
    return axios_instance.put('/api/check_ins/set_billable', {check_in: check_in_row});
  },
  deleteCheckIn(pass_id, check_in_time) {
    return axios_instance.delete(`/api/check_ins/${pass_id}/${check_in_time}`);
  },
  updatePass(passHolderId, typeId, disabled, billable, rfid, barcode, notes, id) {
      return axios_instance.put('/api/passses', {
        pass: {
          pass_holder_id: passHolderId,
          type_id: typeId,
          disabled: disabled,
          billable: billable,
          rfid: rfid,
          barcode: barcode,
          notes: notes,
          id: id
        }
      });
  },
  deletePass(passids) {
      return axios_instance.put('/api/passses', {
        passIds: passids
      });
  },
  deleteUser(userid) {
    console.log('Deleting user with id API: ' + userid);
      return axios_instance.post('/api/organisations/user/delete/' + userid, {
        data: {
          id: userid
        }
      });
  },
  getCheckInsByDate(params){
      return axios_instance.get('/api/check_ins/check_ins_by_date', {
        params: params
      });
  },
  getCheckInsAsCsv(params){
      return axios_instance.get('/api/check_ins/check_ins_by_date/csv', {
        params: params
      });
  },
  getCheckInStats(params){
    return axios_instance.get('/api/check_ins/statistics', {
        params: params
      });
  },
  getBarcodePrefix() {
    return axios_instance.get('/api/configuration/barcodePrefix');
  },
  checkin(barcode, check_in_type, notes, organisation_id, customTime, manualCheckInReason){
    var data = {
      barcode: barcode,
      check_in_type: check_in_type,
      notes: notes,
      custom_time: customTime,
      manual_check_in_reason: manualCheckInReason
    };
    if (organisation_id) {
      data.organisation_id = organisation_id;
    }
    return axios_instance.post('/api/check_ins/check_in', data);
  },
  getAllOrganisationUsers(params){
    return axios_instance.get('/api/organisations/user_accounts', {
      params: params
    });
  },
  getAllOrganisations(){
    return axios_instance.get('/api/organisations/all');
  },
  getOrganisationById(organisationId) {
    return axios_instance.get(`/api/organisations/${organisationId}`);
  },
  getAllOrganisationNames(){
    return axios_instance.get('/api/organisations/', {});
  },
  updateOrganisationUser(id, org_id, enabled, name, full_name, username, email, has_skiing, has_non_ski_day){
    return axios_instance.put('/api/organisations/user_accounts', {
      id: id,
      org_id: org_id,
      enabled: enabled,
      name: name,
      full_name: full_name,
      username: username,
      email: email,
      has_skiing: has_skiing,
      has_non_ski_day: has_non_ski_day
    });
  },
  async createOrganisationAccount(organisation){
    return axios_instance.post('/api/organisations/organisation', organisation);
  },
  async createUserAccount(userAccount) {
    await axios_instance.post('/api/organisations/user_accounts', userAccount); 
    await axios_instance.post('/api/users/password_creation_email', userAccount)
  },
  async getPassTypeImage(passTypeId) {
    const res = await axios_instance.get(`/api/pass_types/${passTypeId}/image`, {
      responseType: 'blob'
    }); 
    return res.data;
  },
  updateSkuTags(passTypeId, skuTags){
    return axios_instance.put('/api/pass_types/sku_tags/' + passTypeId, {
      sku_tags: skuTags
    });
  },
  getSkuTags(passTypeId){
    return axios_instance.get('/api/pass_types/sku_tags/' + passTypeId);
  },
  async getPassGroupDetailsFromToken(token) {
    const res = await axios_instance.get(`/api/passes/group/${token}`); return res.data.ret_msg;
  },
  async postCsvData(data) {
    try {
      const response = await axios_instance.post('/api/passes/csv', data);

      console.log('Upload successful:', response);
      return response;
    } catch (error) {
      console.error('Upload failed:', error);
    }
  },
  setPassToPrinted(passId) {
    return axios_instance.post(`/api/passes/${passId}/print`); 
  },
  removeLocalUser () {
        localStorage.removeItem(USER_ID_KEY)
        localStorage.removeItem(USER_FULL_NAME_KEY)
        localStorage.removeItem(USER_IS_ADMIN_KEY)
        localStorage.removeItem(SESSION_KEY)
        localStorage.removeItem(USER_MANAGE_OWN_PASSES);
        localStorage.removeItem(USER_ORGANISATION_ID);
        localStorage.removeItem(USER_HAS_MEMBERSHIP_PASS);
        localStorage.removeItem(USER_ALLOW_MANUAL_BARCODE);
        
        if(this.onAuthChange !== undefined) {
            this.onAuthChange(false)
        }
  },
  saveBarcodePrefix(barcodePrefix) {
    return axios_instance.put('/api/configuration/barcodePrefix', {
      barcodePrefix
    }); 
  },
  async saveGroup(token, details) {
    const res = await axios_instance.post(`/api/passes/group/${token}`, details);
  },
  async getLinkedUsers(token) {
    const res = await axios_instance.get(`/api/users/groups/${token}/linked`);
    return res.data;
  }
}

axios_instance.interceptors.request.use(
    request => {
        var session = localStorage.getItem(SESSION_KEY)
        if(session != undefined) {
            request.headers['x-session-token'] = session;
        }
        return request
    },
    error => {
        if(error.response != undefined && error.response.status == 401) {
            exports.removeLocalUser();
        }
        return Promise.reject(error);
    });

axios_instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if(error.response != undefined && error.response.status == 401) {
            exports.removeLocalUser();
        }
        return Promise.reject(error);
    });

 export default exports;



// WEBPACK FOOTER //
// ./src/api.js